export default __webpack_public_path__ + "static/media/Bordro_Kontrol_Ornek_Excel.7a0d0bd4.xlsx";